export default __webpack_public_path__ + "83ee3019b0cc84cd25e841d18fda90f9.woff";